import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-da4e4b4e")

_pushScopeId("data-v-da4e4b4e")
const _hoisted_1 = { class: "w-full flex flex-col font-montserrat" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 z-20 text-black-lp-300" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout" }, " Bulk Upload Komisi Booking ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = { class: "add-bulk-booking-commission flex overflow-y-auto text-black-lp-300 py-8" }
const _hoisted_7 = { class: "flex flex-col w-10/12 gap-8 pb-8" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "text-20px font-semibold" }, "Kriteria Berkas", -1)
const _hoisted_9 = { class: "grid grid-cols-2 gap-x-6 gap-y-8" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-x-6 gap-y-8" }
const _hoisted_11 = { class: "w-full mt-1.5" }
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", { class: "border-gray-lp-400" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "text-20px font-semibold" }, "Aturan Komisi", -1)
const _hoisted_14 = { class: "grid grid-cols-2 gap-x-6 gap-y-8" }
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", { class: "border-gray-lp-400" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "text-20px font-semibold" }, "Perhitungan Tier", -1)
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-7 gap-4 pb-2\" data-v-da4e4b4e><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Tier </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Dimulai Dari </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Sampai </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Komisi Induk </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Komisi cabang </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Komisi di Pick Up </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\" data-v-da4e4b4e> Komisi Pick Up </div></div><div class=\"border-t\" data-v-da4e4b4e></div>", 2)
const _hoisted_20 = { class: "grid grid-cols-7 gap-4" }
const _hoisted_21 = { class: "w-12/12 text-center" }
const _hoisted_22 = { class: "h-4" }
const _hoisted_23 = { class: "w-12/12" }
const _hoisted_24 = { class: "w-12/12" }
const _hoisted_25 = { class: "w-12/12" }
const _hoisted_26 = { class: "w-12/12" }
const _hoisted_27 = { class: "w-12/12" }
const _hoisted_28 = { class: "w-12/12" }
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "text-20px font-semibold" }, "Berkas Lampiran", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_ShipmentIdSelect = _resolveComponent("ShipmentIdSelect")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_upload_file = _resolveComponent("upload-file")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _hoisted_4
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_lp_button, {
            title: "Upload",
            textColor: "white",
            disabled: !_ctx.isFormValid,
            onClick: _cache[2] || (_cache[2] = () => _ctx.handleConfirmationSave(true))
          }, null, 8, ["disabled"])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Tipe Berkas"
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.documentTypeName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.documentTypeName = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Nama Aktifitas"
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  type: "textarea",
                  modelValue: _ctx.form.activityName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.activityName = $event)),
                  placeholder: "Berkas bulk komisi booking",
                  textAreaRows: "2"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Deskripsi",
              optional: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  type: "textarea",
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.description = $event)),
                  placeholder: "Lorem ipsum",
                  textAreaRows: "2"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Sumber Booking"
            }, {
              default: _withId(() => [
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.optionBookingSource,
                  onSelect: _ctx.selectBookingSource,
                  placeholder: "Pilih sumber",
                  isCustomWidth: "",
                  selectedItem: _ctx.form.bookingSource,
                  class: "w-full mt-1.5"
                }, null, 8, ["options", "onSelect", "selectedItem"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Komisi Untuk"
            }, {
              default: _withId(() => [
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.optionAppliedTo,
                  onSelect: _ctx.selectAppliedTo,
                  placeholder: "Pilih",
                  isCustomWidth: "",
                  selectedItem: _ctx.form.appliedTo,
                  class: "w-full mt-1.5",
                  isDisabled: !_ctx.form.bookingSource.value
                }, null, 8, ["options", "onSelect", "selectedItem", "isDisabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2 col-span-2",
              label: "Shipment ID"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_11, [
                  (_ctx.isShipmentIdMandatory)
                    ? (_openBlock(), _createBlock(_component_ShipmentIdSelect, {
                        key: 0,
                        modelValue: _ctx.form.shipmentId,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.shipmentId = $event))
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_LpInput, {
                        key: 1,
                        disabled: true,
                        "model-value": '-'
                      }))
                ])
              ]),
              _: 1
            })
          ]),
          _hoisted_12,
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Acuan Komisi"
            }, {
              default: _withId(() => [
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.optionTierBase,
                  onSelect: _ctx.selectTierBase,
                  placeholder: "Pilih Acuan Komisi",
                  isCustomWidth: "",
                  selectedItem: _ctx.form.tierBase,
                  class: "w-full mt-1.5"
                }, null, 8, ["options", "onSelect", "selectedItem"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Harga Acuan Tier "
            }, {
              default: _withId(() => [
                (_ctx.isPriceTierReferenceMandatory)
                  ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                      key: 0,
                      options: _ctx.optionTierReferencePrice,
                      onSelect: _ctx.selectTierReferencePrice,
                      placeholder: "Pilih tier acuan",
                      isCustomWidth: "",
                      selectedItem: _ctx.form.tierReferencePrice,
                      class: "w-full mt-1.5"
                    }, null, 8, ["options", "onSelect", "selectedItem"]))
                  : (_openBlock(), _createBlock(_component_LpInput, {
                      key: 1,
                      disabled: true,
                      "model-value": '-'
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Tipe Komisi"
            }, {
              default: _withId(() => [
                _createVNode(_component_CustomDropdown, {
                  options: _ctx.optionCommissionType,
                  onSelect: _ctx.selectCommissionType,
                  placeholder: "Pilih komisi",
                  isCustomWidth: "",
                  selectedItem: _ctx.form.commissionType,
                  class: "w-full mt-1.5"
                }, null, 8, ["options", "onSelect", "selectedItem"])
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2",
              label: "Harga Acuan Komisi "
            }, {
              default: _withId(() => [
                (_ctx.isCommissionQuantifierAndPriceReferenceMandatory)
                  ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                      key: 0,
                      options: _ctx.optionCommissionReferencePrice,
                      onSelect: _ctx.selectCommissionReferencePrice,
                      placeholder: "Pilih harga acuan",
                      isCustomWidth: "",
                      selectedItem: _ctx.form.commissionReferencePrice,
                      class: "w-full mt-1.5"
                    }, null, 8, ["options", "onSelect", "selectedItem"]))
                  : (_openBlock(), _createBlock(_component_LpInput, {
                      key: 1,
                      disabled: true,
                      "model-value": '-'
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_data_wrapper, {
              class: "ml-2 col-span-2",
              label: "Parameter Perhitungan"
            }, {
              default: _withId(() => [
                (_ctx.isCommissionQuantifierAndPriceReferenceMandatory)
                  ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                      key: 0,
                      options: _ctx.optionQuantifier,
                      onSelect: _ctx.selectQuantifier,
                      placeholder: "Pilih parameter perhitungan komisi",
                      isCustomWidth: "",
                      selectedItem: _ctx.form.quantifier,
                      class: "w-full mt-1.5"
                    }, null, 8, ["options", "onSelect", "selectedItem"]))
                  : (_openBlock(), _createBlock(_component_LpInput, {
                      key: 1,
                      disabled: true,
                      "model-value": '-'
                    }))
              ]),
              _: 1
            })
          ]),
          _hoisted_15,
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.tierCalculation, (fields, index) => {
              return (_openBlock(), _createBlock("div", {
                key: fields,
                class: "flex flex-wrap flex-row items-center py-6 border-b"
              }, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(index + 1), 1)
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_lp_input, {
                      prefix: _ctx.form.tierBase.value === 'total_base_rate' ? 'IDR' : '',
                      format: _ctx.formatDecimal,
                      modelValue: _ctx.form.tierCalculation[index].from,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.tierCalculation[index].from = $event),
                      suffix: _ctx.form.tierBase.value !== 'total_base_rate' ? 'Kg' : '',
                      error: 
                    _ctx.isFocused &&
                      index > 0 &&
                      _ctx.payload.tierCalculation[index].from <=
                        _ctx.payload.tierCalculation[index - 1].to
                  ,
                      maxValueNumber: 1000000000,
                      isMandatory: true,
                      errorIcon: false,
                      onFocus: _cache[7] || (_cache[7] = () => (_ctx.isFocused = true))
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "suffix", "error"])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_lp_input, {
                      prefix: _ctx.form.tierBase.value === 'total_base_rate' ? 'IDR' : '',
                      format: _ctx.formatDecimal,
                      modelValue: _ctx.form.tierCalculation[index].to,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.tierCalculation[index].to = $event),
                      suffix: _ctx.form.tierBase.value !== 'total_base_rate' ? 'Kg' : '',
                      error: 
                    _ctx.isFocused &&
                      _ctx.payload.tierCalculation[index].to <=
                        _ctx.payload.tierCalculation[index].from
                  ,
                      maxValueNumber: 1000000000,
                      isMandatory: true,
                      errorIcon: false,
                      onFocus: _cache[8] || (_cache[8] = () => (_ctx.isFocused = true))
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "suffix", "error"])
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_lp_input, {
                      prefix: 
                    _ctx.form.commissionType.value !== 'percentage' ? 'IDR' : ''
                  ,
                      format: _ctx.formatDecimal,
                      modelValue: _ctx.form.tierCalculation[index].commission,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.tierCalculation[index].commission = $event),
                      suffix: _ctx.form.commissionType.value === 'percentage' ? '%' : '',
                      maxValueNumber: 
                    _ctx.form.commissionType.value === 'percentage' ? 100 : 1000000
                  ,
                      isMandatory: true,
                      errorIcon: false,
                      onFocus: _cache[9] || (_cache[9] = () => (_ctx.isFocused = true))
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "suffix", "maxValueNumber"])
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode(_component_lp_input, {
                      prefix: 
                    _ctx.form.commissionType.value !== 'percentage' ? 'IDR' : ''
                  ,
                      format: _ctx.formatDecimal,
                      modelValue: _ctx.form.tierCalculation[index].commissionBranch,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.tierCalculation[index].commissionBranch = $event),
                      suffix: _ctx.form.commissionType.value === 'percentage' ? '%' : '',
                      maxValueNumber: 
                    _ctx.form.commissionType.value === 'percentage' ? 100 : 1000000
                  ,
                      isMandatory: true,
                      errorIcon: false,
                      onFocus: _cache[10] || (_cache[10] = () => (_ctx.isFocused = true))
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "suffix", "maxValueNumber"])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode(_component_lp_input, {
                      prefix: 
                    _ctx.form.commissionType.value !== 'percentage' ? 'IDR' : ''
                  ,
                      format: _ctx.formatDecimal,
                      modelValue: _ctx.form.tierCalculation[index].commissionDipickup,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.tierCalculation[index].commissionDipickup = $event),
                      suffix: _ctx.form.commissionType.value === 'percentage' ? '%' : '',
                      maxValueNumber: 
                    _ctx.form.commissionType.value === 'percentage' ? 100 : 1000000
                  ,
                      isMandatory: true,
                      errorIcon: false,
                      onFocus: _cache[11] || (_cache[11] = () => (_ctx.isFocused = true))
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "suffix", "maxValueNumber"])
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode(_component_lp_input, {
                      prefix: 
                    _ctx.form.commissionType.value !== 'percentage' ? 'IDR' : ''
                  ,
                      format: _ctx.formatDecimal,
                      modelValue: _ctx.form.tierCalculation[index].commissionPickup,
                      "onUpdate:modelValue": ($event: any) => (_ctx.form.tierCalculation[index].commissionPickup = $event),
                      suffix: _ctx.form.commissionType.value === 'percentage' ? '%' : '',
                      maxValueNumber: 
                    _ctx.form.commissionType.value === 'percentage' ? 100 : 1000000
                  ,
                      isMandatory: true,
                      errorIcon: false,
                      onFocus: _cache[12] || (_cache[12] = () => (_ctx.isFocused = true))
                    }, null, 8, ["prefix", "format", "modelValue", "onUpdate:modelValue", "suffix", "maxValueNumber"])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _hoisted_29,
          _createVNode(_component_data_wrapper, {
            class: "ml-2 pb-8",
            label: "Upload Berkas"
          }, {
            default: _withId(() => [
              _createVNode(_component_upload_file, {
                type: "csv",
                modelValue: _ctx.form.file,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.file = $event)),
                maxRows: 100000
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      "on-submit": _ctx.onSubmitLeavePage,
      "on-close": _ctx.onCloseLeavePage,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["on-submit", "on-close"]), [
      [_vShow, _ctx.leavePageConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: () => _ctx.handleConfirmationSave(false),
      title: "Konfirmasi Pembuatan",
      message: `Anda yakin ingin mengunggah berkas “Booking Commission” ?`,
      image: "are-you-sure",
      textSuccess: "Process",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.openConfirmationSave]
    ])
  ], 64))
})